import axios from "axios";
import { Response } from "../../../shared/models/Response";
import { PromptsResponse } from "../models/PromptsResponse.model";
import { PromptQuery } from "../models/PromptQuery";

export class PromptsService {
  private baseUrl: string;

  constructor() {
    this.baseUrl = `${process.env.VUE_APP_FORMS_API}/prompts`;
  }

  async savePrompt(prompt: any): Promise<Response<string>> {
    const serviceURL = `${this.baseUrl}`;
    const response = await axios.post(serviceURL, prompt);
    return response.data;
  }

  async getPromptsByFilters(
    filterQuery: PromptQuery
  ): Promise<Response<PromptsResponse[]>> {
    const serviceURL = `${this.baseUrl}/find-by-filters`;
    console.log("filterQuery", filterQuery);
    const response = await axios.get(serviceURL, { params: filterQuery });
    return response.data;
  }
}
